<h1 mat-dialog-title>Gutschrift {{ gutschrift?.gutschrift_id ? "editieren" : "hinzufügen" }}</h1>
<div mat-dialog-content>
    <kiene-autocomplete
        #lieferantAuto
        (elementSelected)="supplierSelected($event)"
        [apiUrl]="'lieferant/'"
        [disabled]="!lieferantFocus"
        [focus]="false"
        [kieneObject]="lieferant"
        [placeholder]="'Lieferant'"
        [presetSelected]="false"
    ></kiene-autocomplete>
    <kiene-article-scan-autocomplete
        (selectedMaterial)="materialSelected($event)"
        [params]="artikelParams"
        [placeholder]="'Artikel'"
        [presetMaterial]="material"
    ></kiene-article-scan-autocomplete>
    <p class="hint">
        Zwei Steuerzeilen auf der Gutschrift? Weitere Position mit anderem MwSt-Satz hinzufügen.
    </p>
    <div class="preis-row" *ngFor="let p of preise; let i = index">
        <mat-form-field class="field-betrag">
            <mat-label>Betrag (netto) in Euro</mat-label>
            <input [(ngModel)]="p.kosten_netto" matInput kieneDeNumber inputmode="decimal" />
            <span matSuffix>&euro;</span>
        </mat-form-field>
        <mat-form-field class="field-mwst">
            <mat-label>MwSt</mat-label>
            <mat-select [(ngModel)]="p.mwstsatz">
                <mat-option *ngFor="let s of mwstSaetze" [value]="s.value">{{ s.label }}</mat-option>
            </mat-select>
        </mat-form-field>
        <button
            mat-icon-button
            type="button"
            class="mwst-calc-btn"
            (click)="mwstVomBetragAbziehen(p)"
            [disabled]="!canMwstVomBetragAbziehen(p)"
            matTooltip="MwSt abziehen (Brutto → Netto)"
        >
            <mat-icon>calculate</mat-icon>
        </button>
        <button
            *ngIf="preise.length > 1"
            mat-icon-button
            type="button"
            class="pos-delete-btn"
            (click)="removePreis(i)"
            matTooltip="Position entfernen"
        >
            <mat-icon>delete</mat-icon>
        </button>
    </div>
    <div class="one-row pos-add">
        <span class="spacer"></span>
        <button mat-stroked-button type="button" color="accent" (click)="addPreis()">
            <mat-icon>add</mat-icon>
            Position hinzufügen
        </button>
    </div>
    <mat-form-field style="width: 100%">
        <mat-label>Gutschrift Nr.</mat-label>
        <input [formControl]="gutschriftNrCtrl" matInput />
    </mat-form-field>
    <mat-form-field style="width: 100%">
        <mat-label>Kommentar</mat-label>
        <input [formControl]="kommentarCtrl" matInput maxlength="500" />
    </mat-form-field>
    <mat-form-field style="width: 100%">
        <mat-label>Gutschriftdatum</mat-label>
        <input [formControl]="datumCtrl" [matDatepicker]="picker" matInput placeholder="Datum Gutschrift" />
        <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <button (click)="openFileSelector()" color="accent" mat-flat-button>Gutschrift als PDF hinzuf&uuml;gen</button>
    <input #fileSelector (change)="handleFiles($event)" accept="application/pdf" style="display: none" type="file" />

    <div *ngIf="filesToUpload.length > 0">
        <mat-list>
            <h4 mat-subheader>Dateien</h4>
            <div *ngFor="let file of filesToUpload; let i = index" style="width: 100%">
                <div class="one-row" style="margin-bottom: 12px">
                    <mat-icon mat-list-icon style="width: 70px">insert_drive_file</mat-icon>
                    <div style="min-width: 40%">{{ file.name }}</div>
                    <mat-icon *ngIf="filesUploadStatus[i] == 1" color="primary">check</mat-icon>
                    <mat-icon *ngIf="filesUploadStatus[i] == 2" color="warn">warning</mat-icon>
                    <span class="spacer"></span>
                    <mat-progress-spinner [diameter]="30" [value]="filesProgressValues[i]" mode="determinate">
                    </mat-progress-spinner>
                </div>
            </div>
        </mat-list>
    </div>
</div>
<div mat-dialog-actions>
    <button (click)="close()" mat-button>Abbrechen</button>
    <button (click)="save()" [disabled]="!lieferant || !hasValidPreise()" color="accent" mat-flat-button
        >Gutschrift Speichern
    </button>
</div>
